<template>
    <div class="spaceBetweenLabel_block" :class="{isBold:isBold}">
      <span v-for="(text,index) in label" :key="index">
        <span class="page_middle_row_key_required" v-if="isRequire && index==0">*</span>
        <span v-if="text==' '">&nbsp;</span>
        <span v-else>{{text}}</span>
        <span v-if="isColon && index==label.length-1">：</span>
      </span>
    </div>
</template>

<script>
export default {
  name: "spaceBetweenLabel",
  props: {
    label: {
      type: String,
      default:""
    },
    isBold:{
      type:Boolean,
      default:true
    },
    isColon:{
      type:Boolean,
      default:true
    },
    isRequire:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style>
.spaceBetweenLabel_block{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.isBold{
  font-weight: bold;
}
</style>